// prefer default export if available
const preferDefault = m => m && m.default || m

exports.components = {
  "component---src-templates-all-pokemon-js": () => import("/opt/build/repo/src/templates/all-pokemon.js" /* webpackChunkName: "component---src-templates-all-pokemon-js" */),
  "component---src-templates-pokemon-js": () => import("/opt/build/repo/src/templates/pokemon.js" /* webpackChunkName: "component---src-templates-pokemon-js" */),
  "component---src-templates-ability-js": () => import("/opt/build/repo/src/templates/ability.js" /* webpackChunkName: "component---src-templates-ability-js" */)
}

exports.data = () => import("/opt/build/repo/.cache/data.json")

